import { atom } from 'jotai';
import { Content, ListedInstrument, PositionTipp } from '../../types';

export type ErsteMarketContentState = {
  isLoading: boolean;
  error: boolean;
  promo: Content[];
  tops: Content[];
};

export type ErsteMarketPositionTippsState = {
  isLoading: boolean;
  error: boolean;
  tipps: PositionTippWithInstrument[];
};

export type PositionTippWithInstrument = PositionTipp & {
  instrument: ListedInstrument;
};

export const ersteMarketContentAtom = atom<ErsteMarketContentState>({
  isLoading: false,
  error: false,
  promo: [],
  tops: [],
});

export const ersteMarketPositionTippsAtom = atom<ErsteMarketPositionTippsState>({
  isLoading: false,
  error: false,
  tipps: [],
});
